<template>
  <div>
    <div>
      <div class="row my-4 mx-1 justify-content-center">
        <v-container v-if="progress" type="image" class="loding">
          <v-skeleton-loader type="image"></v-skeleton-loader>
        </v-container>
        <div v-else class="col-lg-8 col-sm-12 col-md-10 borderPointier">
          <div class="background-white">
            <div class="title">
              <div class="position">
                {{ $t("conditions_technique") }}  
              </div>
            </div>
          </div>
          <form @submit.prevent="isolation_plancherAdd">
            <div>
              <label>
                {{
                  $t("Protéger les matériaux d'isolation contre l'humidité par")
                }}
              </label>
              <b-form-radio-group
                v-model="selected"
                class="mb-3"
                name="isolation-option"
              >
                <div class="row">
                  <div class="col-6">
                    <b-form-radio value="A">{{
                      $t("Pare-vapeur")
                    }}</b-form-radio>
                  </div>
                  <div class="col-6">
                    <b-form-radio value="B">{{ $t("Autre") }}</b-form-radio>
                  </div>
                </div>
              </b-form-radio-group>
            </div>
            <b-form-group
              label-for="select-type-appareil"
            >
              <template #label>
    {{ $t('Types_isolants_thermiques') }} <span class="text-danger">*</span>
  </template>
              <b-form-select
                v-model="type_isolant"
                :options="typeAppareilOptions"
                id="select-type-appareil"
                class="custom-input"
              >
              </b-form-select>
            </b-form-group>

            <div class="fieldset mb-2" v-if="type_isolant">
              <div class="legend mb-2">
    {{ type_isolant === 'reflechesson_et_non_reflichessant' ? 'norme reflichessant' : $t('NORM') }} <span class="text-danger">*</span>
              </div>
              <b-form-input
                type="text"
                v-model="norme"
                id="select-norme"
                :placeholder="type_isolant === 'reflechesson_et_non_reflichessant' ? 'norme reflichessant' : $t('NORM')"
                class="form-input custom-placeholder custom-input"
              >
              </b-form-input>
            </div>
            <!-- Deuxième norme si option combinée est sélectionnée -->
            <div class="fieldset mb-2" v-if="type_isolant === 'reflechesson_et_non_reflichessant'">
              <div class="legend mb-2">
    norme non reflichessant <span class="text-danger">*</span>
              </div>
              <b-form-input
                type="text"
                v-model="norme2"
                id="select-norme2"
                placeholder="norme non reflichessant"
                class="form-input custom-placeholder custom-input"
              >
              </b-form-input>
            </div>
            <div class="fieldset mb-2">
              <div class="legend mb-2">
                {{ $t("surface_isolant") }}   <span class="text-danger">*</span> 
              </div>
              <b-form-input
                type="number"
                min="0"
                @paste="
                  (event) =>
                    onPaste(event, 'isolation_plancherData.Surface_isolant')
                "
                @keydown="(event) => onKeyDown(event)"
                v-model="isolation_plancherData.Surface_isolant"
                :placeholder="$t('surface_isolant')"
                class="form-input custom-placeholder custom-input"
              >
              </b-form-input>
            </div>
            <div class="fieldset mb-2">
              <div class="legend mb-2">
                {{ $t("resistance_thermique") }}   <span class="text-danger">*</span> 
              </div>
              <b-form-input
                type="number"
                min="0"
                @keydown="(event) => onKeyDown(event)"
                @paste="
                  (event) =>
                    onPaste(
                      event,
                      'isolation_plancherData.resistance_thermique'
                    )
                "
                v-model="isolation_plancherData.resistance_thermique"
                :placeholder="$t('resistance_thermique')"
                class="form-input custom-placeholder custom-input"
              >
              </b-form-input>
            </div>
            <div class="fieldset mb-2">
              <div class="legend mb-2">
                {{ $t("epaisseur") }}   <span class="text-danger">*</span> 
              </div>
              <b-form-input
                type="number"
                min="0"
                @keydown="(event) => onKeyDown(event)"
                @paste="
                  (event) => onPaste(event, 'isolation_plancherData.epaisseur')
                "
                v-model="isolation_plancherData.epaisseur"
                :placeholder="$t('epaisseur')"
                class="form-input custom-placeholder custom-input"
              >
              </b-form-input>
            </div>
            
            <!-- Champs contact sur site -->
            <div class="fieldset mb-2">
              <div class="legend mb-2">
                {{ $t("Contact sur site") || "Contact sur site" }}
              </div>
              <b-form-input
                type="text"
                v-model="contactSurSite"
                :placeholder="$t('Contact sur site') || 'Contact sur site'"
                class="form-input custom-placeholder custom-input"
                @input="updateContactSurSite"
              />
            </div>
            
            <div class="fieldset mb-2">
              <div class="legend mb-2">
                {{ $t("Fonction") || "Fonction" }}
              </div>
              <b-form-input
                type="text"
                v-model="fonctionContact"
                :placeholder="$t('Fonction') || 'Fonction'"
                class="form-input custom-placeholder custom-input"
                @input="updateFonctionContact"
              />
            </div>
            
            <div class="fieldset mb-2">
              <div class="legend mb-2">
                {{ $t("Téléphone") || "Téléphone" }}
              </div>
              <phone
                :tel="telephoneContact"
                @phoneNumber="formatTelephoneContact($event)"
              ></phone>
            </div>
          </form>
    
        </div>
      </div>
     
    </div>
    <!-- <div v-if="show" class="d-flex justify-content-end mt-4">
            <b-button v-if="this.visibleTabsLength<=1" @click="goToPrevStep" class="button-pre-style m-3">
        {{ $t("PREVIOUS") }}
      </b-button>
      <b-button
        type="submit"
        @click="goToStep"
        class="button-suivant-style m-3"
      >
        <template v-if="isLoading">
          <div class="loading ml-2">
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </div>
        </template>
      
        <template >
          {{ buttonText }}
        </template>
      </b-button>
    </div> -->
    <div v-if="!show" class="d-flex justify-content-end mt-4">
      <b-button @click="goToPrevStep" class="button-pre-style m-3">
        {{ $t("PREVIOUS") }}
      </b-button>
      <b-button
        type="submit"
        @click="goToStep"
        class="button-suivant-style m-3"
      >
        {{ $t("NEXT") }}
        <div class="loading ml-2" v-if="isLoading">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
        <div class="loading ml-2" v-if="isLoadingButton">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
      </b-button>
    </div>
    <Snackbar ref="snackbar" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import domain from "@/environment";
import axios from "axios";
import Snackbar from "@/components/ui/errorSnackbar.vue";
import phone from "@/components/ui/phone.vue";
import { handlePaste, preventExceedingLengthFloat } from "@/utils/inputUtils";
export default {
  components: {
    Snackbar,
    phone,
  },
  props: {
    visibleTabsLength: {
      type: Number,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
      
    },
    isLoadingButton: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCompleted: false,
      errorMessage: "",
      isLoading: false,
      selected: "A",
      selectedTypePose: null,
      isolation_plancherData: null,
      isolation_plancher: false,
      type_isolant: null,
      norme: null,
      norme2: null,
      contactSurSite: null,
      fonctionContact: null,
      telephoneContact: null,
      options_type_pose: [
        { value: "en combles perdu", text: this.$t("en combles perdu") },
        {
          value: "en rampant de toitures",
          text: this.$t("en rampant de toitures"),
        },
      ],
      typeAppareilOptions: [
        { value: null, text: this.$t("Sélectionnez_type"), disabled: true },
        { value: "non reflechissant", text: this.$t("non_reflechissant") },
        { value: "reflechissant", text: this.$t("reflechissant") },
        { value: "reflechesson_et_non_reflichessant", text: this.$t("reflechesson et non reflichessant") }, // option combinée

      ],
    };
  },
  created() {
    if (this.getdevisMonoFiche && this.getdevisMonoFiche.data) {
      this.isolation_plancherData = this.initializeisolation_plancher();
      if (this.isolation_plancherData.id !== null) {
        this.isCompleted = true;
      }
      if (this.isolation_plancherData.necessite_pare_vapeur === 1) {
        this.selected = "A";
      } else {
        this.selected = "B";
      }
      this.initializeContactFields();
    }
  },
  computed: {
    ...mapState({
      token: (state) => state.token,
    }),
    ...mapGetters(["getdevisMonoFiche"]),
    buttonText() {
      return this.visibleTabsLength <= 1 ? this.$t("NEXT") : this.$t("CONFIRMER");
    },
  },

  watch: {
    getdevisMonoFiche: {
      handler(newDevis) {
        if (newDevis && newDevis.data) {
          // Préserver les valeurs locales existantes
          const currentSurface = this.isolation_plancherData?.Surface_isolant;
          const currentEpaisseur = this.isolation_plancherData?.epaisseur;
          const currentResistance = this.isolation_plancherData?.resistance_thermique;
          const currentTypeIsolant = this.type_isolant;
          const currentNorme = this.norme;
          const currentNorme2 = this.norme2;
          
          this.isolation_plancherData = this.initializeisolation_plancher();
          
          // Restaurer les valeurs locales si elles existent
          if (currentSurface !== undefined && currentSurface !== "") {
            this.isolation_plancherData.Surface_isolant = currentSurface;
          }
          if (currentEpaisseur !== undefined && currentEpaisseur !== "") {
            this.isolation_plancherData.epaisseur = currentEpaisseur;
          }
          if (currentResistance !== undefined && currentResistance !== "") {
            this.isolation_plancherData.resistance_thermique = currentResistance;
          }
          if (currentTypeIsolant !== null && currentTypeIsolant !== undefined) {
            this.type_isolant = currentTypeIsolant;
          }
          if (currentNorme !== null && currentNorme !== undefined) {
            this.norme = currentNorme;
          }
          if (currentNorme2 !== null && currentNorme2 !== undefined) {
            this.norme2 = currentNorme2;
          }
          
          this.isolation_plancher =
            newDevis.data?.devis.isolation_plancher !== null;
          if (!this.type_isolant) {
          this.type_isolant =
            newDevis.data?.devis?.isolation_plancher?.type_isolant || null;
          }
          if (!this.norme) {
          this.norme = newDevis.data?.devis?.isolation_plancher?.norme || null;
          }
          if (!this.norme2) {
          this.norme2 = newDevis.data?.devis?.isolation_plancher?.norme2 || null;
          }
          this.initializeContactFields();
          if (this.isolation_plancher) {
            this.isCompleted = true;
          }
          if (this.isolation_plancher && this.isolation_plancher.necessite_pare_vapeur === 1) {
            this.selected = "A";
          } else if (this.isolation_plancher && this.isolation_plancher.necessite_pare_vapeur !== 1) {
            this.selected = "B";
          }
        }
      },
      deep: true,
      immediate: true,
      "isolation_plancherData.type_pose": {
        handler(newValue) {
          this.selectedTypePose = newValue
            ? "en combles perdu"
            : "en rampant de toitures";
        },
        immediate: true,
        "isolation_plancherData.necessite_pare_vapeur": {
          handler(newValue) {
            this.selected = newValue === 1 ? "A" : "B";
          },
          immediate: true,
        },
      },
    },
    type_isolant(newVal) {
      if (newVal !== 'reflechesson_et_non_reflichessant') {
        this.norme2 = null;
      }
    },
  },
  methods: {
    ...mapActions(["setDevisMonoFiche"]),

    onKeyDown(event) {
      preventExceedingLengthFloat(event);
    },

    onPaste(event, fieldName) {
      handlePaste.call(this, event, fieldName);
    },
    async postIsolationCombleToiture(payload) {
      try {
        const response = await axios.post(
          domain + `/isolation_plancher`,
          payload,
          {
            headers: {
              Authorization: `Bearer ` + this.token,
            },
          }
        );
        return response.data.data;
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          this.errorMessage = error.response.data.message;
        } else if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          this.errorMessage = error.response.data.errors.join(", ");
        } else {
          this.errorMessage = "Vérifiez vos données.";
        }
        this.$refs.snackbar.showSnackbar(this.errorMessage);
        return null;
      }
    },
    async putIsolationCombleToiture(payload) {
      try {
        const response = await axios.put(
          domain + `/isolation_plancher/${payload.id}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ` + this.token,
            },
          }
        );

        return response.data.data;
      } catch (error) {
        throw new Error("Failed to post isolation combles toiture.");
      }
    },
    initializeisolation_plancher() {
      const isolation_plancher =
        this.getdevisMonoFiche?.data?.devis.isolation_plancher || {};
      this.selectedTypePose = isolation_plancher.type_isolant
        ? "non reflechissant"
        : "reflechissant";

      return {
        id: isolation_plancher.id,
        necessite_pare_vapeur: isolation_plancher.necessite_pare_vapeur || 0,
        resistance_thermique: isolation_plancher.resistance_thermique || "",
        norme: isolation_plancher.norme || "",
        norme2: isolation_plancher.norme2 || "",
        epaisseur: isolation_plancher.epaisseur || "",
        Surface_isolant: isolation_plancher.Surface_isolant || "",
        type_isolant: isolation_plancher.type_isolant || "",
      };
    },
    async isolationAdd() {
      if (this.selected === "A") {
        this.isolation_plancherData.necessite_pare_vapeur = 1;
      } else {
        this.isolation_plancherData.necessite_pare_vapeur = 0;
      }
      if(!this.type_isolant ||!this.norme ||!this.selectedTypePose){
        this.errorMessage ="Tous_obligatoires"
        return;
      }
      if (this.type_isolant === "reflechesson_et_non_reflichessant" && !this.norme2) {
        this.errorMessage = "Norme 2 est obligatoire";
        return;
      }
      this.isolation_plancherData.type_isolant = this.type_isolant;
      this.isolation_plancherData.norme = this.norme;
      this.isolation_plancherData.norme2 = this.type_isolant === 'reflechesson_et_non_reflichessant' ? this.norme2 : null;
      this.isolation_plancherData.type_pose = this.selectedTypePose;
      
      // S'assurer que les valeurs numériques sont correctement formatées
      const payload = {
        ...this.isolation_plancherData,
        Surface_isolant: this.isolation_plancherData.Surface_isolant && this.isolation_plancherData.Surface_isolant !== "" 
          ? parseFloat(this.isolation_plancherData.Surface_isolant) 
          : null,
        epaisseur: this.isolation_plancherData.epaisseur && this.isolation_plancherData.epaisseur !== "" 
          ? parseFloat(this.isolation_plancherData.epaisseur) 
          : null,
        resistance_thermique: this.isolation_plancherData.resistance_thermique && this.isolation_plancherData.resistance_thermique !== "" 
          ? parseFloat(this.isolation_plancherData.resistance_thermique) 
          : null,
      };
      
      const response = await this.postIsolationCombleToiture(payload);

      if (response.id !== null) {
        this.getdevisMonoFiche.data.devis.isolation_plancher_id = response.id;
        this.getdevisMonoFiche.data.devis.isolation_plancher = {
          id: this.getdevisMonoFiche.data.devis.isolation_plancher_id,
          Surface_isolant: this.isolation_plancherData.Surface_isolant,
          epaisseur: this.isolation_plancherData.epaisseur,
          resistance_thermique:
            this.isolation_plancherData.resistance_thermique,
          norme: this.isolation_plancherData.norme,
          norme2: this.isolation_plancherData.norme2,
          necessite_pare_vapeur:
            this.isolation_plancherData.necessite_pare_vapeur,
          type_pose: this.isolation_plancherData.type_pose,
          type_isolant: this.isolation_plancherData.type_isolant,
        };
        this.setDevisMonoFiche(this.getdevisMonoFiche);
        return response;
      } else {
        this.isLoading = false;

        return;
      }
    },

    async isolation_plancherAdd() {
      if (this.isolation_plancher) {
        if (this.selected === "A") {
          this.isolation_plancherData.necessite_pare_vapeur = 1;
        } else {
          this.isolation_plancherData.necessite_pare_vapeur = 0;
        }
        this.isolation_plancherData.type_isolant = this.type_isolant;
        this.isolation_plancherData.norme = this.norme;
        this.isolation_plancherData.norme2 = this.norme2;
        this.isolation_plancherData.type_pose = this.selectedTypePose;
        
        // S'assurer que les valeurs numériques sont correctement formatées
        const chauffe = {
          ...this.isolation_plancherData,
          id: this.getdevisMonoFiche.data.devis.isolation_plancher.id,
          Surface_isolant: this.isolation_plancherData.Surface_isolant && this.isolation_plancherData.Surface_isolant !== "" 
            ? parseFloat(this.isolation_plancherData.Surface_isolant) 
            : null,
          epaisseur: this.isolation_plancherData.epaisseur && this.isolation_plancherData.epaisseur !== "" 
            ? parseFloat(this.isolation_plancherData.epaisseur) 
            : null,
          resistance_thermique: this.isolation_plancherData.resistance_thermique && this.isolation_plancherData.resistance_thermique !== "" 
            ? parseFloat(this.isolation_plancherData.resistance_thermique) 
            : null,
        };

        const reponse = await this.putIsolationCombleToiture(chauffe);
        this.getdevisMonoFiche.data.devis.isolation_plancher = {
          id: this.getdevisMonoFiche.data.devis.isolation_plancher.id,
          Surface_isolant: this.isolation_plancherData.Surface_isolant,
          resistance_thermique:
            this.isolation_plancherData.resistance_thermique,
          epaisseur: this.isolation_plancherData.epaisseur,
          norme: this.isolation_plancherData.norme,
          norme2: this.isolation_plancherData.norme2,
          necessite_pare_vapeur:
            this.isolation_plancherData.necessite_pare_vapeur,
          type_pose: this.isolation_plancherData.type_pose,
          type_isolant: this.isolation_plancherData.type_isolant,
        };

        this.setDevisMonoFiche(this.getdevisMonoFiche);
        return reponse;
      }
      await this.isolationAdd();
    },
    async goToStep() {
      this.isLoading = true;
      if (this.isolation_plancherData.Surface_isolant == "") {
        this.isLoading = false;
        this.isCompleted = false;
        this.$refs.snackbar.showSnackbar("Tous_obligatoires");
        return;
      }
      
      // Valider que norme2 est obligatoire si option combinée est sélectionnée
      if (this.type_isolant === "reflechesson_et_non_reflichessant" && !this.norme2) {
        this.isLoading = false;
        this.isCompleted = false;
        this.$refs.snackbar.showSnackbar(this.$t('NORM') + " 2 est obligatoire");
        return;
      }

      await this.isolation_plancherAdd();
      if (this.errorMessage !== "") {
        this.isLoading = false;
        this.isCompleted = false;
        this.$refs.snackbar.showSnackbar("Tous_obligatoires");
        return;
      }
 
      if(this.visibleTabsLength<=1){
        this.$emit("change",true);
      }
      this.isLoading = false;
      this.isCompleted = false;
    },
    async goToNextStep() {
      this.isLoading = true;
      if (this.isolation_plancherData.Surface_isolant == "") {
        this.isLoading = false;
        this.$emit("changeStep", 5, true);
        return;
      }
      
      // Valider que norme2 est obligatoire si option combinée est sélectionnée
      if (this.type_isolant === "reflechesson_et_non_reflichessant" && !this.norme2) {
        this.isLoading = false;
        this.$refs.snackbar.showSnackbar(this.$t('NORM') + " 2 est obligatoire");
        return;
      }

      await this.isolation_plancherAdd();
      if (this.errorMessage !== "") {
        this.isLoading = false;

        return;
      }
      this.isLoading = false;
      this.$emit("changeStep", 5, true);
    },
    initializeContactFields() {
      const devis = this.getdevisMonoFiche?.data?.devis;
      this.contactSurSite = devis?.contact_sur_site || null;
      this.fonctionContact = devis?.fonction_contact || null;
      this.telephoneContact = devis?.telephone_contact || null;
    },
    updateContactSurSite() {
      this.getdevisMonoFiche.data.devis.contact_sur_site = this.contactSurSite || null;
      this.setDevisMonoFiche(this.getdevisMonoFiche);
    },
    updateFonctionContact() {
      this.getdevisMonoFiche.data.devis.fonction_contact = this.fonctionContact || null;
      this.setDevisMonoFiche(this.getdevisMonoFiche);
    },
    formatTelephoneContact(event) {
      if (event && event.number && event.country) {
        this.telephoneContact = {
          phone_number: event.number,
          phone_iso_code: event.country.iso2,
          formated_phone: event.formatted || null,
        };
        this.getdevisMonoFiche.data.devis.telephone_contact = this.telephoneContact;
        this.setDevisMonoFiche(this.getdevisMonoFiche);
      } else if (!event || !event.number) {
        this.telephoneContact = null;
        this.getdevisMonoFiche.data.devis.telephone_contact = null;
        this.setDevisMonoFiche(this.getdevisMonoFiche);
      }
    },
    goToPrevStep() {
      if(this.visibleTabsLength<=1){
        this.$emit("changePrev",true);
      }else {
        this.$emit("changePrev",false);
      }
      this.$emit("changeStep", 3);
    },
  },
};
</script>
<style scoped>
.custom-placeholder::placeholder {
  font-size: 13px;
}
.form-input {
  font-size: 13px;
  height: 41.1px !important;
}
.borderPointier {
  border: 2px dashed #24316d;
  position: relative;
}
.input-style {
  margin-bottom: 1rem;
  border-radius: 4px;
  border: 1px solid #eaebec;
  padding: 0.5rem 0.75rem;
  background-color: #fff;
}

.background-white {
  display: inline-block;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  position: absolute;
  top: -1rem;
  left: 0;
  right: 0;
  z-index: 1;
  text-align: center;
}
.title {
  color: #24316d;
  position: relative;
  z-index: 2;
  margin: 0;
}

.position {
  background-color: white;
  display: inline-block;
  padding: 0.05rem 2rem;
}
.custom-input {
  box-shadow: none;
}
.small-spinner .spinner-border {
  width: 1rem;
  height: 1rem;
}
</style>
